import RtSidebarMenu from './src/rtSidebarMenu';
export default RtSidebarMenu;



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/sidebarMenu/index.js